import { render, staticRenderFns } from "./UIAddressInputs.vue?vue&type=template&id=8acfd616&scoped=true&"
import script from "./UIAddressInputs.vue?vue&type=script&lang=js&"
export * from "./UIAddressInputs.vue?vue&type=script&lang=js&"
import style0 from "./UIAddressInputs.vue?vue&type=style&index=0&id=8acfd616&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader-virtual-c5444c0a66/0/cache/vue-loader-npm-15.9.1-90a0e5830b-a9a3ffbe3c.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acfd616",
  null
  
)

export default component.exports